export const COMMISSION_TABLE_NAME = 'commissions';

// The columns available to be shown in a technician services table.
export const COMMISSION_TABLE_COLUMNS = {
  start_date: { label: 'Dates', key: 'start_date' },
  location_id: { label: 'Location', key: 'location_id' },
  service_id: { label: 'Service', key: 'service_id' },
  commission_plan_id: { label: 'Commission Plan', key: 'commission_plan_id' },
  actions: { label: 'Actions', key: 'actions' },
};

// The default columns to be shown when the technician services table loads.
export const COMMISSION_TABLE_DEFAULT_COLUMNS = [
  COMMISSION_TABLE_COLUMNS.commission_plan_id,
  COMMISSION_TABLE_COLUMNS.service_id,
  COMMISSION_TABLE_COLUMNS.start_date,
  COMMISSION_TABLE_COLUMNS.actions,
];
